export function setupContactForm()
{
    const routes = window.app.routes;

    let form = document.querySelector('.contact-form');

    form.addEventListener('submit', event => {
        event.preventDefault();

        let data = new FormData(form);
        let url = routes.BASE_REST_URL + routes.NAME_SPACE + '/' + routes.CONTACT_FORM;

        let grecaptchaResponseToken = window.grecaptcha.getResponse();
        data.append('grecaptchaResponseToken', grecaptchaResponseToken);
        data.delete('g-recaptcha-response');

        let successMessage = document.querySelector('.contact-form-success-message');
        let errorMessage = document.querySelector('.contact-form-error-message');

        fetch(url, { method: 'POST', body: data }).then(response => {
            response.json().then(data => {
                if (grecaptchaResponseToken) {
                    window.grecaptcha.reset();
                }

                successMessage.textContent = '';
                errorMessage.textContent = '';

                if (data.message) {
                    if (data.status) {
                        successMessage.textContent = data.message;
                    }
                    else {
                        errorMessage.textContent = data.message;
                    }
                }

                if (data.status) {
                    form.reset();
                }
            });
        });
    });
}
